import { useQuery } from '@tanstack/react-query';
import { BaseHTTPError } from '@fe-core/errors';
import { useConfigContext } from '@fe-core';
import { getSelfregSessionChildren } from '@api/queries/selfreg';
import { TSessionChildren } from '@api/io/session.children.io';

const QUERY_KEY = 'selfreg-session-children';

export const useSelfregSessionChildren = ({
  sessionId,
}: {
  sessionId: string;
}) => {
  const { config } = useConfigContext();
  const baseUrl = config.apiUrls.ccapi;

  return useQuery<TSessionChildren, BaseHTTPError>({
    queryKey: [QUERY_KEY, sessionId],
    queryFn: () =>
      getSelfregSessionChildren({ baseUrl: baseUrl as string, sessionId }),
    retry: false,
    staleTime: 0,
    enabled: !!baseUrl,
  });
};
